import {useTranslation} from "react-i18next";
import React, { useContext } from "react";
import '../BranchClusteringStyles.css'
import Branch from "../../../interfaces/Branch";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";
import { RegionSelectedContext } from "../../../contexts/RegionSelectedContext";
import LatamConcentrationRecord from "../../../models/LatamConcentrationRecord";
import Barchart, { BarData } from "../../Charts/Barchart";
import SimpleBarchart, { SimpleBarData } from "../../Charts/SimpleBarchart";
import BranchChartWithTitle from "../../Commons/BranchChartWithTitle";
import BranchChartRow from "../../Commons/BranchChartRow";
import LegendComponent from "../../LegendsGraphics/LegendGraphic";
import styled from "styled-components";


const SquareColor = styled.div`
    height: 16px;
    width: 16px;
    margin-right: 10px;

    &.light-grey {
      background-color: #8b8b8b;
    }

    &.dark-grey {
      background-color: #464646;
    }

    &.red {
      background-color: #CC0000
    }
`;

const PeriodYearComponent: React.FC = () => {
    const {t} = useTranslation();
    // @ts-ignore
    const { yearSelected } = useContext(RegionSelectedContext);

    return (
        <div className={'detailChartMarginBottom40 periodYearContainer'}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='light-grey' />
                <div>{ t('latamMarketConcentration.thirdChartLegend1', { yearStart: yearSelected - 10, yearEnd: yearSelected - 1 }) }</div>
            </div>

            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='dark-grey' />
                <div>{ t('latamMarketConcentration.thirdChartLegend2', { year: yearSelected }) }</div>
            </div>

            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='red' />
                <div>{ t('latamMarketConcentration.thirdChartLegend3', { yearStart: yearSelected - 10, yearEnd: yearSelected })}</div>
            </div>
        </div>
    )
};

const LifeRanking = () => {
    const { t } = useTranslation();
    // @ts-ignore
    const { latamConcentrationRecords } = useContext(GlobalDataContext);
    // @ts-ignore
    const { yearSelected } = useContext(RegionSelectedContext);

    const records =
      latamConcentrationRecords
        .filter((x: LatamConcentrationRecord) => x.branch === Branch.LIFE)
        .filter((x: LatamConcentrationRecord) => x.year === yearSelected);

    const simpleBars: SimpleBarData[] =
      records
        .map((x: LatamConcentrationRecord) => ({ 'group': x.company_group, 'value': x.herfindahl_cont_year }));

    const bars: BarData[] =
      records
        .sort((r1: LatamConcentrationRecord, r2: LatamConcentrationRecord) => r2.herfindahl_var_last_10_years - r1.herfindahl_var_last_10_years)
        .map((x: LatamConcentrationRecord) => {
          return {
            group: x.company_group,
            bars: [x.herfindahl_var_last_10_years_last_year, x.herfindahl_var_last_year],
            point: x.herfindahl_var_last_10_years
          };
        });

    const charts = [
      <BranchChartWithTitle
        key={ 1 }
        title={ t('latamBranchConcentration.leftChartTitle', { year: yearSelected }) }
        chartLegend={ <div style={{ height: 60 }} /> }
        chart={
          <SimpleBarchart
            bars={ simpleBars }
            isDark={ true }
          />
        }
      />,
      <BranchChartWithTitle
        key={ 2 }
        title={ t('latamBranchConcentration.rightChartTitle', { yearStart: yearSelected - 10, yearEnd: yearSelected }) }
        chartLegend={ <PeriodYearComponent /> }
        chart={
          <Barchart
            bars={ bars }
            isDark={ true }
            barColors={ ['#8B8B8B', '#464646', '#FAA3A3'] }
            formatVerticalTicks={ (n) => `${Math.round(n * 100)}%` }
          />
        }
      />
    ]

    return (
      <BranchChartRow
        rowTitle={ t('latamBranchConcentration.lifeRankingTitle') }
        charts={ charts }
      />
    );
};

export default LifeRanking;
